import React from "react";
import { Zap, Target, Cpu } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const values = [{
  id: "01",
  title: "Landscape Design",
  description: "Our creative team blends native flora with architectural principles to craft outdoor living spaces that evolve beautifully with the seasons.",
  icon: Zap
}, {
  id: "02",
  title: "Hardscape Artistry",
  description: "From custom patios to structural retaining walls, we use premium materials to build functional elements with meticulous attention to detail.",
  icon: Target
}, {
  id: "03",
  title: "Lawn Maintenance",
  description: "Advanced water management systems designed to maintain lush greenery while optimizing conservation for Rockland and Orange County properties.",
  icon: Cpu
}];
export default function OurValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="9240" id="service-categories" ref={ref} className={`bg-background text-foreground py-24 relative overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-20 max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-default font-bold tracking-tight mb-4 text-primary">
            Our Specialized Services
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            From Rockland to Orange County, Twins Landscaping Corp. delivers meticulous outdoor solutions designed to enhance your property's value and natural beauty.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {values.map((value, i) => <div key={value.id} data-index={i} className="group relative">
              <Card className="h-full bg-background border-transparent backdrop-blur-sm overflow-hidden hover:bg-muted transition-colors duration-300">
                <CardContent className="p-8 relative h-full flex flex-col justify-center">
                  {}
                  <div className="absolute -right-4 -bottom-8 text-9xl font-black leading-none select-none pointer-events-none z-0 transition-transform duration-500 group-hover:scale-110 origin-bottom-right" style={{
                WebkitTextStroke: "1px var(--color-accent)",
                color: "transparent",
                opacity: 0.15
              }}>
                    {value.id}
                  </div>

                  {}
                  <div className="relative z-10">
                    <div className="mb-6 inline-flex items-center justify-center w-14 h-14 rounded-sm bg-accent text-accent-foreground border border-accent/20 shadow-[0_0_15px_rgba(var(--color-accent),0.3)] group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300">
                      <value.icon className="w-7 h-7" />
                    </div>
                    
                    <h3 className="text-2xl font-default font-bold mb-4 tracking-tight text-primary group-hover:text-accent-foreground transition-colors duration-300">
                      {value.title}
                    </h3>
                    
                    <p className="text-muted-foreground font-default leading-relaxed min-h-[4.5rem]">
                      {value.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}